'use es6';

import ObjectBuilderClient from './components/ObjectBuilderClient';

// do something interesting!
export default ObjectBuilderClient;